import * as types from './mutation-types';

export const setDrawer = ({ commit }, drawer) => {
  commit(types.SET_DRAWER, drawer)
}
